import { render, staticRenderFns } from "./bloodGlucoseList.vue?vue&type=template&id=372bdf36&scoped=true"
import script from "./bloodGlucoseList.vue?vue&type=script&lang=js"
export * from "./bloodGlucoseList.vue?vue&type=script&lang=js"
import style0 from "./bloodGlucoseList.vue?vue&type=style&index=0&id=372bdf36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372bdf36",
  null
  
)

export default component.exports